import { client } from "@/api/client";
import interceptors from "@/api/interceptor";

client.interceptors.request.use(interceptors.noAuth, interceptors.onError);


function getSiteConfig() {
	return client.get("options/site-config");
}

function getCourier() {
	return client.get("options/courier");
}

function getOngkir(params) {
	return client.get("common/ongkir", {
		params: params,
	});
}

function getShippingFeeKiriminajaExpress(params) {
	return client.get("expka/ongkir/search-express-trx", {
		params: params,
	});
}

function getShippingFeeKiriminajaInstant(params) {
	return client.get("expka/ongkir/search-instant-trx", {
		params: params,
	});
}

function getProvince() {
	return client.get("expka/area/area-province");
}

function getCity(params) {
	return client.get("expka/area/area-city", {
		params: params,
	});
}

function getSubdistrict(params) {
	return client.get("expka/area/area-subdistrict", {
		params: params,
	});
}

function getBankList(params) {
	return client.get("options/bank", {
		params: params,
	});
}

function getBankAccountList(params) {
	return client.get("options/bank-account", {
		params: params,
	});
}

function getPaymentMethodList(params) {
	return client.get("options/payment-method", {
		params: params,
	});
}
function getSosmedAccountList(params) {
	return client.get("options/sosmed-account", {
		params: params,
	});
}  

export default {
	getCourier,
	getOngkir,
	getProvince,
	getSosmedAccountList,
	getCity,
	getSubdistrict,
	getBankList,
	getBankAccountList,
	getPaymentMethodList,
	getShippingFeeKiriminajaExpress,
	getShippingFeeKiriminajaInstant,
	getSiteConfig
};